<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Coil Options</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (coilConstructionSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Coil Construction:</label>
            <select
              class="halfWidthInputField"
              #coilConstructionInput
              [class.invalidConfigurationSelection]="isInvalidSelection(coilConstructionSelection.Name)"
              (change)="selectionChanged(coilConstructionSelection, coilConstructionInput.value)"
              [value]="coilConstructionSelection.Value.toString()">
              @for (allowable of coilConstructionSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="coilConstructionSelection.Value && coilConstructionSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </span>
        }
        @if (autoAirVentsSelection) {
          <span class="halfWidthConfigurationInput">
            <label
              [class.invalidConfigurationSelection]="isInvalidSelection(autoAirVentsSelection.Name)"
              for="autoAirVentsInput"
              class="halfWidthInputLabel">
              Auto Air Vents
            </label>
            <input
              type="checkbox"
              class="checkboxInput"
              id="autoAirVentsInput"
              #autoAirVentsInput
              [checked]="'true' === autoAirVentsSelection.Value"
              (change)="selectionChanged(autoAirVentsSelection, autoAirVentsInput.checked.toString())" />
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        <span class="halfWidthConfigurationInput">
          <span class="halfWidthInputLabel"></span>
        </span>
        @if (preHeatSelection) {
          <span class="halfWidthConfigurationInput">
            <label
              [class.invalidConfigurationSelection]="isInvalidSelection(preHeatSelection.Name)"
              for="preHeatInput"
              class="halfWidthInputLabel">
              PreHeat
            </label>
            <input
              type="checkbox"
              class="checkboxInput"
              id="preHeatInput"
              #preHeatInput
              [checked]="'true' === preHeatSelection.Value"
              (change)="selectionChanged(preHeatSelection, preHeatInput.checked.toString())" />
          </span>
        }
      </div>
    </div>
  }
</div>
